import { render } from "./SupplierReturnForm.vue?vue&type=template&id=58b40398&scoped=true"
import script from "./SupplierReturnForm.vue?vue&type=script&lang=js"
export * from "./SupplierReturnForm.vue?vue&type=script&lang=js"

import "./SupplierReturnForm.vue?vue&type=style&index=0&id=58b40398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b40398"]])

export default __exports__